/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var HandPointIcon16Solid = forwardRef('HandPointIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.938 15.002h-4.33a1.65 1.65 0 0 1-1.124-.443l-4.31-4.016a1.626 1.626 0 0 1 1.968-2.57L6 9.13v-7.13a1.5 1.5 0 0 1 3 0V5.8l3.837.69a2.25 2.25 0 0 1 1.788 2.74l-1.083 4.508a1.65 1.65 0 0 1-1.604 1.264Z" })));
});
